const WindowWidthType = {
  SM: 576,
  MD: 960,
  LG: 1290,
};

export default WindowWidthType;
